import { render, staticRenderFns } from "./RegistrationContainer.vue?vue&type=template&id=15ab4d38&scoped=true"
import script from "./RegistrationContainer.vue?vue&type=script&lang=js"
export * from "./RegistrationContainer.vue?vue&type=script&lang=js"
import style0 from "./RegistrationContainer.vue?vue&type=style&index=0&id=15ab4d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab4d38",
  null
  
)

export default component.exports